import { z } from 'zod';
import { LANGUAGES } from './options';

export const MAX_IMAGE_TEXT_BYTES = 10 * 1024 * 1024;
export const IMAGE_TEXT_MEDIA_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;

/** What's done with an image: the text in it read out, or what it shows described. */
export const IMAGE_MODES = ['text', 'describe'] as const;
export type ImageMode = (typeof IMAGE_MODES)[number];

/**
 * How to read an uploaded image, sent in its query string. Without a mode its text is read, as
 * before there was a choice; a description is written in `language`.
 */
export const ImageTextQuerySchema = z.object({
  mode: z.enum(IMAGE_MODES).default('text'),
  language: z.enum(LANGUAGES).exclude(['auto']).default('en'),
});
export type ImageTextQuery = z.infer<typeof ImageTextQuerySchema>;

export const ImageTextResponseSchema = z.object({
  text: z
    .string()
    .trim()
    .min(1)
    .max(256 * 1024),
});

/** Whether an uploaded image can be read, and how. */
export const ImageTextConfigSchema = z.object({
  enabled: z.boolean(),
  // A server from before descriptions only reads text.
  modes: z.array(z.enum(IMAGE_MODES)).default(['text']),
});
export type ImageTextConfig = z.infer<typeof ImageTextConfigSchema>;
